import { registerApplication, start, addErrorHandler } from 'single-spa';
import { constructApplications, constructRoutes, constructLayoutEngine } from 'single-spa-layout';

import {
    routes as cloudRoutes,
    initSentry,
    mfFallbackHandler,
    getSsoToken,
    getRootRedirect,
    getAQAModeFlags,
    getIsAdminRole,
    getIsMemberRole,
} from './utils';
import { makeRoutes } from './makeRoutes';
import './styles/global-styles.css';

initSentry();

const ssoToken = getSsoToken();
const isMember = getIsMemberRole(ssoToken);
const isAdmin = getIsAdminRole(ssoToken);
const aqaFlags = getAQAModeFlags();

const resolvedRoutes = makeRoutes({ isMember });

const routes = constructRoutes({
    routes: resolvedRoutes,
    redirects: {
        '/': getRootRedirect({ isMember, isAdmin, aqaFlags }) + window.location.search,
        '/cloud-shield': '/cybershield',
    },
});

const applications = constructApplications({
    routes,
    loadApp({ name }) {
        return System.import(name);
    },
});

const layoutEngine = constructLayoutEngine({
    routes,
    applications,
    active: false,
});

const OMIT_BILLING_BANNER_ROUTES = [
    cloudRoutes.wizard,
    cloudRoutes.selectPlan,
    cloudRoutes.tenants,
];

applications.forEach(app => {
    // We don't want to render billing banner on some pages
    if (app.name === '@openvpn/billing-banner-mf') {
        registerApplication({
            ...app,
            activeWhen: [
                ({ pathname }) =>
                    pathname !== '/' &&
                    OMIT_BILLING_BANNER_ROUTES.every(t => !pathname.startsWith(t)) &&
                    !aqaFlags.includes('-billing-banner'),
            ],
        });
    } else {
        registerApplication(app);
    }
});

layoutEngine.activate();
start();

if (isMember) {
    document.title = `CloudConnexa | User Portal`;
}

if (process.env.NODE_ENV === 'development') {
    /**
     * This handler will try to fallback to a deployed verison of failed MFE.
     * This is handly if you're developing only one MFE and don't need to start others locally.
     */
    addErrorHandler(mfFallbackHandler);
}
